var _defs, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCelebrate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            path\n            {\n                fill: #263c53;\n            }\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.93,239.35l30.4-52.67a86.78,86.78,0,0,1-15.67-2.86L86.88,212.89,77.71,201.5l-14.44-2.24,15.47-26.8A86.87,86.87,0,0,1,66.88,163L39.33,210.72l30.34,4.71Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M167.12,212.89l-16.76-29a86.5,86.5,0,0,1-15.68,2.83l30.39,52.65,19.26-23.92,30.34-4.71L187.12,163a86.73,86.73,0,0,1-11.86,9.47l15.47,26.79-14.44,2.24Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.92,150.81a72.34,72.34,0,0,0,11.64,9.84A74,74,0,0,0,127,173.43h.14a73.31,73.31,0,0,0,37.77-10.49c1.21-.73,2.39-1.5,3.55-2.29a73.57,73.57,0,1,0-94.52-9.84Zm61.42,7a57.66,57.66,0,0,1-16.66,0l-.74-.1a59,59,0,0,1-24.86-10.1A58.58,58.58,0,0,1,126.9,41.31a58.94,58.94,0,0,1,14.27,1.76,58.54,58.54,0,0,1,19.74,104.54c-1.21.86-2.45,1.7-3.75,2.48A58.36,58.36,0,0,1,136,157.74Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCelebrate);
export default __webpack_public_path__ + "static/media/celebrate.4ed08e2b00c90db8c417807cb04dafea.svg";
export { ForwardRef as ReactComponent };